import React from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  GOLD_PACKAGE,
  SILVER_PACKAGE,
  BRONZE_PACKAGE,
} from "../../backend/PAYMENT_PACKAGES_CONSTANTS";

const PackageSelection = ({
  onSelectPackage,
  onCompleteRegistration,
  selectedPackage = null,
  isProcessing = false,
  onBack,
}) => {
  const packages = [
    {
      name: "bronze",
      title: "תוכנית הארד",
      price: `₪${BRONZE_PACKAGE.PRICE}`,
      period: "לחודש",
      features: [
        `עד ${BRONZE_PACKAGE.NUMBER_OF_GROUPS} קבוצות`,
        `עד מאמן אחד`,
        "ללא הגבלת ספורטאים",
        "דשבורד ניהול",
      ],
      bgGradient: "linear-gradient(135deg, #f2e6dc, #cd7f32)",
    },
    {
      name: "silver",
      title: "תוכנית הכסף",
      price: `₪${SILVER_PACKAGE.PRICE}`,
      period: "לחודש",
      features: [
        `עד ${SILVER_PACKAGE.NUMBER_OF_GROUPS} קבוצות`,
        `עד ${SILVER_PACKAGE.NUMBER_OF_COACHES} מאמנים`,
        "ללא הגבלת ספורטאים",
        "דשבורד ניהול",
      ],
      popular: true,
      bgGradient: "linear-gradient(135deg, #f8f9fa, #c0c0c0)",
    },
    {
      name: "gold",
      title: "תוכנית הזהב",
      price: `₪${GOLD_PACKAGE.PRICE}`,
      period: "לחודש",
      features: [
        `עד ${GOLD_PACKAGE.NUMBER_OF_GROUPS} קבוצות`,
        `עד ${GOLD_PACKAGE.NUMBER_OF_COACHES} מאמנים`,
        "ללא הגבלת ספורטאים",
        "דשבורד ניהול",
        "הטמעת לוגו הארגון בדוחות המידע",
        'תמיכה טלפונית 24/7, כולל סופ"ש',
        "הדרכה אישית לצוות הארגון על המערכת",
      ],
      bgGradient: "linear-gradient(135deg, #fffbe6, #d4af37)",
    },
  ];

  const handlePackageSelect = (packageName) => {
    if (!isProcessing) {
      // This only updates the selected package, doesn't trigger registration
      onSelectPackage(packageName);
    }
  };

  const handleCompleteRegistration = () => {
    if (selectedPackage && !isProcessing) {
      // This triggers the actual registration process
      onCompleteRegistration(selectedPackage);
    }
  };

  return (
    <Container className="" dir="rtl">
      <h2 className="text-center fw-bold mb-4">בחרו את המסלול שמתאים לכם</h2>
      <div className="trial-banner mb-5 p-4 bg-success bg-opacity-10 border border-success rounded">
        <h4 className="fw-semibold mb-2">3 חודשי ניסיון בחינם!</h4>
        <p className="mb-0 ">אנחנו באמת מאמינים שתאהבו את המערכת שלנו - </p>
        <p className="mb-0 ">
          ולכן אנחנו נותנים לכם תקופת ניסיון ארוכה על חשבוננו!
        </p>
      </div>

      <Row className="g-4">
        {packages.map((pkg) => (
          <Col key={pkg.name} md={6} lg={4} style={{ height: "100%" }}>
            <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
              <Card
                className={`h-100 d-flex flex-column shadow border-0 position-relative ${
                  selectedPackage === pkg.name ? "ring" : ""
                }`}
                onClick={() => handlePackageSelect(pkg.name)}
                style={{
                  background: pkg.bgGradient,
                  color: "#333",
                  borderRadius: "1rem",
                  cursor: "pointer",
                  minHeight: "650px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "stretch",
                  border:
                    selectedPackage === pkg.name ? "3px solid #2563eb" : "none",
                  boxShadow:
                    selectedPackage === pkg.name
                      ? "0 0 0 3px #2563eb55"
                      : undefined,
                }}
              >
                {pkg.popular && (
                  <div
                    style={{
                      position: "absolute",
                      top: -30,
                      right: 0,
                      margin: "1rem",
                    }}
                  >
                    <span className="badge bg-warning text-dark px-3 py-1 rounded-pill shadow">
                      הכי פופולרי
                    </span>
                  </div>
                )}
                <Card.Body
                  className="flex-grow-1 d-flex flex-column justify-content-between"
                  style={{
                    minHeight: "340px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Card.Title className="text-center fw-bold fs-4 mb-3">
                      {pkg.title}
                    </Card.Title>
                    <div className="text-center mb-4">
                      <h3 className="mb-0">{pkg.price}</h3>
                      <small className="text-muted">{pkg.period}</small>
                    </div>
                    <div className="px-3">
                      {pkg.features.map((feature, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center bg-white bg-opacity-75 rounded p-2 mb-2 shadow-sm"
                          style={{ textAlign: "center" }}
                        >
                          <span
                            className=""
                            style={{ fontWeight: "bold", fontSize: "0.8rem" }}
                          >
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 text-center p-3">
                  <Button
                    className="w-100 fw-bold"
                    disabled={isProcessing}
                    style={{
                      background:
                        selectedPackage === pkg.name
                          ? "#2563eb"
                          : pkg.bgGradient,
                      color:
                        selectedPackage === pkg.name
                          ? "#fff"
                          : pkg.name === "bronze"
                          ? "#5a3a1b"
                          : pkg.name === "silver"
                          ? "#333"
                          : "#fff",
                      border: "none",
                      boxShadow:
                        selectedPackage === pkg.name
                          ? "0 0 0 3px #2563eb55"
                          : undefined,
                    }}
                  >
                    {selectedPackage === pkg.name ? "✓ נבחר" : "בחר חבילה"}
                  </Button>
                </Card.Footer>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>

      {/* Complete Registration Button */}
      <div className="d-flex justify-content-between gap-3 mt-5">
        <Button
          variant="outline-secondary"
          onClick={onBack}
          disabled={isProcessing}
          className="px-5 py-3 fw-bold flex-fill"
        >
          חזור
        </Button>
        <Button
          variant="success"
          size="lg"
          className="px-5 py-3 fw-bold flex-fill"
          disabled={!selectedPackage || isProcessing}
          onClick={handleCompleteRegistration}
        >
          {isProcessing ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              מעבד...
            </>
          ) : (
            "סיים הרשמה"
          )}
        </Button>
      </div>
      {!selectedPackage && (
        <p className="text-muted mt-2 text-center">יש לבחור חבילה כדי להמשיך</p>
      )}
    </Container>
  );
};

export default PackageSelection;
